import { Component, Output, EventEmitter, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HideIconDirective } from './hideicondirective';
import { CommonModule } from '@angular/common';
import { Subject, Subscription, debounceTime } from 'rxjs';

@Component({
  standalone: true,
  selector: 'wms-search',
  // Usage in parent component: <wms-search (onSearch)="filterWidgets($event.searchKey)"></wms-search>
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less'],
  imports: [ HideIconDirective, FormsModule, CommonModule ]
})
export class SearchComponent  implements OnDestroy {

  @Input() searchKey: string;
  @Input() disabled: boolean = false;
  @Input() placeholder: any = "Search...";
  @Input() width: string = "100%";
  @Input() name: string = "text-search-input";
  @Output() onSearch: EventEmitter<{searchKey: string;}>;
  @ViewChild('searchinputEl', { static: true }) searchInputRef!: ElementRef<HTMLInputElement>;
  hideSearchIcon: boolean;
  modelChanged = new Subject<string>();
  changeSubscription: Subscription

  constructor() {
    this.searchKey = '';
    this.onSearch = new EventEmitter<{searchKey: string;}>();
    this.hideSearchIcon = true;
    this.changeSubscription = this.modelChanged.pipe(debounceTime(300)).subscribe(()=>{
      this.onFilter()
    })
  }

  onFilter(): void {
    this.hideSearchIcon = false;
    if (this.searchKey == '') {
      this.hideSearchIcon = true;
    }
    this.onSearch.emit({ searchKey: this.searchKey });
  }

  clearSearch(): void {
    this.hideSearchIcon = true;
    this.searchKey = '';
    this.onSearch.emit({ searchKey: this.searchKey });
    //After clearing the search text, focus the input to allow immediate typing
    this.searchInputRef.nativeElement.focus();
  }

  changed() {
    this.modelChanged.next('');
  }

  ngOnDestroy(){
    if(this.changeSubscription)
      this.changeSubscription.unsubscribe();
  }
}
